export default [{
  mainButton: {
    name: 'forecast-view',
    label: 'Comparative',
    tooltip: 'Comparative charts',
    goTo: '?forecastChartType=spline'
  },
  hideSeparator: true
}, {
  mainButton: {
    name: 'forecast-view-filled',
    label: 'Cumulative',
    tooltip: 'Cumulative charts',
    goTo: '?forecastChartType=area-spline'
  }
}, {
  mainButton: {
    name: 'uploadDownload',
    label: 'Upload /<br>Download',
    tooltip: 'Uploading and downloading data',
    menu: [{
      name: 'upload',
      label: 'upload workload',
      goTo: '?modal=ForecastUpload'
    }, {
      name: 'download',
      label: 'Download "The need for staff"',
      goTo: '?modal=ForecastDownload'
    }]
  }
}];